/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
// import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import * as wjCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { clearAlert, setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除, 画面ロック開始 } from "../../../globalStore/progressStore"
import ZyomuinKyuyoMasterV2Service from "../../../service/driverpayroll/zyomuinKyuyoMasterV2/zyomuinKyuyoMasterService"

import dayjs from "dayjs"
import ComboBox from "../../../components/ComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import { 区分分類コード } from "../../../constant/enum/codes"
import { e評価区分 } from "../../../constant/enum/syain"
import { RootState } from "../../../globalStore/rootreducer"
import {
  TZyomuinKyuyoMasterV2GetRes,
  TZyomuinKyuyoMasterV2RegisterPostReq,
  TZyomuinKyuyoMasterV2RegisterPutReq,
} from "../../../service/driverpayroll/zyomuinKyuyoMasterV2/TZyomuinKyuyoMaster"
import KubunService from "../../../service/master/kubun/kubunService"
import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import dateUtil from "../../../ts/util/dateUtil"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

/**
 * 乗務員給与マスタ 登録
 * @returns
 */
const ZyomuinKyuyoMasterV2Register = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  const disPatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // ID
  const [乗務員給与ID, set乗務員給与ID] = useState<number>()
  // 表示項目のstate
  const [部所名, set部所名] = useState<string>("")
  const [社員コード, set社員コード] = useState<string>("")
  const [社員氏名, set社員氏名] = useState<string>("")
  const [年齢, set年齢] = useState<string>("")
  const [在籍年数, set在籍年数] = useState<string>("")
  const [評価区分コード, set評価区分コード] = useState<string | null>()
  const [計算用評価区分コード, set計算用評価区分コード] = useState<string | null>()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [県コード, set県コード] = useState<string | null>()
  const [退職年月日, set退職年月日] = useState<string>("")
  const [業務内容, set業務内容] = useState<string>("")

  const [基本給, set基本給] = useState<number>()
  const [住宅手当, set住宅手当] = useState<number>()
  const [勤続手当, set勤続手当] = useState<number>()
  const [永年勤続手当, set永年勤続手当] = useState<number>()
  const [地域最低単価, set地域最低単価] = useState<number>()
  const [評価手当, set評価手当] = useState<number>()
  const [業務手当, set業務手当] = useState<number>()
  const [資格手当, set資格手当] = useState<number>()
  const [通勤費, set通勤費] = useState<number>()
  const [通勤費税込, set通勤費税込] = useState<number>()
  const [固定給フラグ, set固定給フラグ] = useState<number>(0)

  const [最終更新日時, set最終更新日時] = useState<string>()
  const [最終更新ID, set最終更新ID] = useState<string>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // ComboBoxState
  // 評価区分
  const [評価区分ComboBox, set評価区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [評価区分IsLoadEnded, set評価区分IsLoadEnded] = useState<boolean>(false)

  // 計算用評価区分
  const [計算用評価区分ComboBox, set計算用評価区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [計算用評価区分IsLoadEnded, set計算用評価区分IsLoadEnded] = useState<boolean>(false)

  //エラー表示用フラグ
  const [isInvalid評価区分, setIsInvalid評価区分] = useState<boolean>()

  //#endregion

  //#region [method]
  /**
   * 検索
   */
  const search = async (id: number) => {
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const service = new ZyomuinKyuyoMasterV2Service()

      const res = (await service.get(id)) as TApiResponse<TZyomuinKyuyoMasterV2GetRes>

      if (res.data) {
        // 乗務員給与ID
        set乗務員給与ID(res.data.乗務員給与ID)
        set部所名(res.data.部所名)
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)
        set県コード(res.data.県コード)

        // 年齢
        if (res.data.生年月日 != null && !wjCore.isNullOrWhiteSpace(res.data.生年月日)) {
          const today = dayjs(eigyobi)
          set年齢(today.diff(res.data.生年月日, "year").toString())
        }
        // 在籍年数
        const 在籍年月数Str = dateUtil.to在籍年月数Str(eigyobi, res.data.入社年月日, res.data.退職年月日)
        set在籍年数(在籍年月数Str)
        set退職年月日(dateUtil.format(res.data.退職年月日))
        set業務内容(res.data.業務内容 ?? "")

        const 基本給区分 = 区分ItemSource?.find((区分) => {
          return 区分.分類コード === 区分分類コード.社員_乗務員.乗務員基本給
        })

        const 地域最低賃金 = 区分ItemSource?.find((区分) => {
          return 区分.区分コード === res.data.県コード && 区分.分類コード === 区分分類コード.社員_乗務員.地域最低賃金
        })

        // 基本給
        if (res.data.乗務員給与ID != null) {
          set評価区分コード(res.data.評価区分コード)
          set計算用評価区分コード(res.data.計算用評価区分コード)

          set基本給(res.data.基本給)
          set住宅手当(res.data.住宅手当)
          set地域最低単価(res.data.地域最低単価)
          set評価手当(res.data.評価手当)
          set固定給フラグ(res.data.固定給フラグ)

          set最終更新日時(res.data.更新日時)
          set最終更新ID(res.data.更新ユーザID ? res.data.更新ユーザID.toString() : "")
        } else {
          set評価区分コード(e評価区分.B)
          set計算用評価区分コード(e評価区分.B)

          set基本給(基本給区分?.数値1)
          set住宅手当(基本給区分?.数値2)
          set地域最低単価(地域最低賃金?.数値1)
          set評価手当(基本給区分?.数値3)
        }

        set勤続手当(res.data.勤続手当)
        set永年勤続手当(res.data.永年勤続手当)
        set業務手当(res.data.業務手当)
        set資格手当(res.data.資格手当)
        set通勤費(res.data.通勤費_非課税)
        set通勤費税込(res.data.通勤費_課税)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
    }
  }

  /**
   * 更新アイテム生成
   */
  const createPutZyomuinKyuyo = (): TZyomuinKyuyoMasterV2RegisterPutReq => {
    return {
      乗務員給与ID,
      乗務員ID: id!,
      業務内容: 業務内容 ?? "",
      基本給: 基本給 ?? 0,
      住宅手当: 住宅手当 ?? 0,
      勤続手当: 勤続手当 ?? 0,
      永年勤続手当: 永年勤続手当 ?? 0,
      地域最低単価: 地域最低単価 ?? 0,
      評価手当: 評価手当 ?? 0,
      業務手当: 業務手当 ?? 0,
      資格手当: 資格手当 ?? 0,
      通勤費_非課税: 通勤費 ?? 0,
      通勤費_課税: 通勤費税込 ?? 0,
      評価区分コード: 評価区分コード ?? "",
      計算用評価区分コード: 計算用評価区分コード || null,
      固定給フラグ,
      更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
    }
  }

  /**
   * 登録アイテム生成
   */
  const createPostZyomuinKyuyo = (): TZyomuinKyuyoMasterV2RegisterPostReq => {
    return {
      乗務員ID: id!,
      業務内容: 業務内容 ?? "",
      基本給: 基本給 ?? 0,
      住宅手当: 住宅手当 ?? 0,
      勤続手当: 勤続手当 ?? 0,
      永年勤続手当: 永年勤続手当 ?? 0,
      地域最低単価: 地域最低単価 ?? 0,
      評価手当: 評価手当 ?? 0,
      業務手当: 業務手当 ?? 0,
      資格手当: 資格手当 ?? 0,
      通勤費_非課税: 通勤費 ?? 0,
      通勤費_課税: 通勤費税込 ?? 0,
      評価区分コード: 評価区分コード ?? "",
      計算用評価区分コード: 計算用評価区分コード || null,
      固定給フラグ,
      更新日時: 最終更新日時 ? 最終更新日時.toString() : "",
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装
    let messages: string[] = []
    let isError = false
    let isValidate = true
    //評価区分チェック
    const 乗務員給与マスタValid = 乗務員給与マスタValidate()
    isError = 乗務員給与マスタValid.hasError === true ? true : isError
    messages.push(...乗務員給与マスタValid.message)
    if (isError) {
      disPatch(setWarningAlerts(messages))
      isValidate = false
    }
    if (!isValidate) {
      setIsConfirmModalShow(false)
      setIsInvalid評価区分(true)
      return
    } else {
      setIsConfirmModalShow(true)
    }
  }

  const 乗務員給与マスタValidate = () => {
    let 評価区分エラーチェック = false
    let エラーメッセージList: string[] = []

    //評価区分エラーチェック
    if (!評価区分コード) {
      評価区分エラーチェック = true
      エラーメッセージList.push("評価区分は必須入力です。")
    }
    return {
      hasError: 評価区分エラーチェック,
      message: エラーメッセージList,
    }
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      if (id == null) return

      if (
        基本給 == null ||
        住宅手当 == null ||
        勤続手当 == null ||
        永年勤続手当 == null ||
        地域最低単価 == null ||
        通勤費 == null ||
        評価手当 == null ||
        業務手当 == null ||
        通勤費税込 == null ||
        評価区分コード == null ||
        県コード == null
      )
        // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
        return

      const service = new ZyomuinKyuyoMasterV2Service()
      let res: TApiResponse<boolean>

      // 乗務員が持ってる給与IDの有無で処理分岐
      if (乗務員給与ID) {
        res = await service.put(id, createPutZyomuinKyuyo())
      } else {
        res = await service.post(id, createPostZyomuinKyuyo())
      }

      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`乗務員給与の更新が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 基本給最新取得
   */
  const updateKihonkyu = () => {
    const 基本給区分 = 区分ItemSource?.find((区分) => {
      return 区分.分類コード === 区分分類コード.社員_乗務員.乗務員基本給
    })
    const 地域最低賃金 = 区分ItemSource?.find((区分) => {
      return 区分.区分コード === 県コード && 区分.分類コード === 区分分類コード.社員_乗務員.地域最低賃金
    })
    set基本給(基本給区分?.数値1)
    set住宅手当(基本給区分?.数値2)
    set地域最低単価(地域最低賃金?.数値1)
  }
  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
    })
  }, [])

  useEffect(() => {
    if (!区分ItemSource) return

    if (id) {
      search(id).finally(() => {
        disPatch(画面ロック解除())
      })
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    }
  }, [区分ItemSource])

  //#endregion

  return (
    <>
      <Prompt when={isPrompt.current} message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">乗務員給与マスタ {乗務員給与ID ? "更新" : "登録"}(新)</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-55rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 所属部所 */}
                  <MasterRegisterFormRow label="所属部所" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="所属部所"
                        name="所属部所"
                        value={部所名}
                        setValue={(v) => {
                          set部所名(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 社員 */}
                  <MasterRegisterFormRow label="社員コード" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="社員コード"
                        name="社員コード"
                        value={社員コード}
                        setValue={(v) => {
                          set社員コード(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 社員氏名 */}
                  <MasterRegisterFormRow label="氏名（漢字）" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="社員氏名"
                        name="社員氏名"
                        value={社員氏名}
                        setValue={(v) => {
                          set社員氏名(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 年齢 */}
                  <MasterRegisterFormRow label="年齢" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="年齢"
                        name="年齢"
                        value={年齢}
                        setValue={(v) => {
                          set年齢(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 在籍年数 */}
                  <MasterRegisterFormRow label="在籍年数" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="在籍年数"
                        name="在籍年数"
                        value={在籍年数}
                        setValue={(v) => {
                          set在籍年数(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 評価区分 */}
                  <MasterRegisterFormRow label="評価区分" isRequired={true}>
                    <div className="w-6rem">
                      <ComboBox.Kubun
                        isEmpty
                        autoFocus={true}
                        分類コード={区分分類コード.社員_乗務員.評価区分}
                        itemsSource={区分ItemSource}
                        selectedValue={評価区分コード}
                        setSelectedValue={set評価区分コード}
                        listFilter={(d) => d.分類コード === 区分分類コード.社員_乗務員.評価区分}
                        isLoadEnded={評価区分IsLoadEnded}
                        setIsLoadEnded={set評価区分IsLoadEnded}
                        ComboBox={評価区分ComboBox}
                        setComboBox={set評価区分ComboBox}
                        className={isInvalid評価区分 ? "is-error" : ""}></ComboBox.Kubun>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 計算用評価区分 */}
                  <MasterRegisterFormRow label="評価区分（計算用）" isRequired={false} isRemarks={false}>
                    <div className="w-6rem">
                      <ComboBox.Kubun
                        isEmpty
                        分類コード={区分分類コード.社員_乗務員.評価区分}
                        itemsSource={区分ItemSource}
                        selectedValue={計算用評価区分コード}
                        setSelectedValue={set計算用評価区分コード}
                        listFilter={(d) => d.分類コード === 区分分類コード.社員_乗務員.評価区分}
                        isLoadEnded={計算用評価区分IsLoadEnded}
                        setIsLoadEnded={set計算用評価区分IsLoadEnded}
                        ComboBox={計算用評価区分ComboBox}
                        setComboBox={set計算用評価区分ComboBox}
                      />
                      <span className="ms-2 text-danger align-self-center" style={{ whiteSpace: "nowrap" }}>
                        ※上の評価区分を変更してもリセットしなければ連動しません
                      </span>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 退職日 */}
                  <MasterRegisterFormRow label="退職日">
                    <div className="w-6rem">
                      <TextInput
                        id="退職年月日"
                        name="退職年月日"
                        value={退職年月日}
                        setValue={(v) => {
                          set退職年月日(v)
                        }}
                        isReadOnly
                      />
                    </div>
                  </MasterRegisterFormRow>

                  {/* 業務内容(備考欄) */}
                  <MasterRegisterFormRow label="業務内容">
                    <div style={{ width: "32rem" }}>
                      <TextInput
                        id="業務内容"
                        name="業務内容"
                        value={業務内容}
                        setValue={(v) => {
                          set業務内容(v)
                        }}
                        maxLength={100}
                        isFulFilledWidth
                      />
                    </div>
                  </MasterRegisterFormRow>

                  <br></br>
                  {/* TODO:NumberInputの制御問題 */}

                  {/* 基本給 */}
                  <MasterRegisterFormRow label="基本給" isRequired={true}>
                    <wjrInput.InputNumber
                      initialized={(control: wjcInput.InputNumber) => {
                        control.inputElement?.focus()
                      }}
                      style={{ width: "8rem" }}
                      id="基本給"
                      name="基本給"
                      format={"N0"}
                      focus
                      value={基本給}
                      setValue={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set基本給(c.value) : set基本給(undefined)
                      }}
                      isReadOnly
                    />
                    <Col className="mb-2" xl={{ span: "auto", offset: "1" }}>
                      <Button
                        type="submit"
                        variant="waiting"
                        onClick={(e) => {
                          updateKihonkyu()
                        }}>
                        基本給最新取得
                      </Button>
                    </Col>
                  </MasterRegisterFormRow>

                  {/* 住宅手当 */}
                  <MasterRegisterFormRow label="住宅手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="住宅手当"
                      name="住宅手当"
                      format={"N0"}
                      isRequired={true}
                      value={住宅手当}
                      setValue={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set住宅手当(c.value) : set住宅手当(undefined)
                      }}
                      isReadOnly
                    />
                  </MasterRegisterFormRow>

                  {/* 勤続手当 */}
                  <MasterRegisterFormRow label="勤続手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="勤続手当"
                      name="勤続手当"
                      format={"N0"}
                      value={勤続手当}
                      setValue={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set勤続手当(c.value) : set勤続手当(undefined)
                      }}
                      isReadOnly
                    />
                  </MasterRegisterFormRow>

                  {/* 永年勤続手当 */}
                  <MasterRegisterFormRow label="永年勤続手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="永年勤続手当"
                      name="永年勤続手当"
                      format={"N0"}
                      value={永年勤続手当}
                      setValue={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set永年勤続手当(c.value) : set永年勤続手当(undefined)
                      }}
                      isReadOnly
                    />
                  </MasterRegisterFormRow>

                  {/* 地域最低単価 */}
                  <MasterRegisterFormRow label="地域最低単価" isRequired={true} isRemarks={false}>
                    <div>
                      <wjrInput.InputNumber
                        style={{ width: "8rem" }}
                        id="地域最低単価"
                        name="地域最低単価"
                        format={"N0"}
                        value={地域最低単価}
                        setValue={(c: wjcInput.InputNumber, e: any) => {
                          c.value != null ? set地域最低単価(c.value) : set地域最低単価(undefined)
                        }}
                        isReadOnly
                      />
                      <div>
                        <span className="ms-2 text-danger align-self-center" style={{ whiteSpace: "nowrap" }}>
                          ※対象月の初日に所属していた部所の地域最低賃金を使用します。
                        </span>
                      </div>
                    </div>
                  </MasterRegisterFormRow>

                  {/* 評価手当 */}
                  <MasterRegisterFormRow label="評価手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="評価手当"
                      name="評価手当"
                      format={"N0"}
                      value={評価手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set評価手当(c.value) : set評価手当(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>

                  {/* 業務手当 */}
                  <MasterRegisterFormRow label="業務手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="業務手当"
                      name="業務手当"
                      format={"N0"}
                      value={業務手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set業務手当(c.value) : set業務手当(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>

                  {/* 業務手当 */}
                  <MasterRegisterFormRow label="資格手当" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="資格手当"
                      name="資格手当"
                      format={"N0"}
                      value={資格手当}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set資格手当(c.value) : set資格手当(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>

                  {/* 通勤費 */}
                  <MasterRegisterFormRow label="通勤費" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="通勤費"
                      name="通勤費"
                      format={"N0"}
                      value={通勤費}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set通勤費(c.value) : set通勤費(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 通勤費税込 */}
                  <MasterRegisterFormRow label="通勤費税込" isRequired={true}>
                    <wjrInput.InputNumber
                      style={{ width: "8rem" }}
                      id="通勤費税込"
                      name="通勤費税込"
                      format={"N0"}
                      value={通勤費税込}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set通勤費税込(c.value) : set通勤費税込(undefined)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 固定給フラグ */}
                  <MasterRegisterFormRow label="固定給フラグ" isRequired={true}>
                    <div className="mt-1">
                      <CheckInput
                        label="（チェックで稼働手当をゼロにします）"
                        type={"checkbox"}
                        id="固定給フラグ"
                        value={固定給フラグ}
                        setValue={set固定給フラグ}
                      />
                    </div>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {乗務員給与ID && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          <Col className=" mb-3" xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {乗務員給与ID ? `更新` : `登録`}
            </Button>
          </Col>
          <Col>
            <Button type="button" variant="secondary" onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal isShow={isConfirmModalShow} hideHandler={setIsConfirmModalShow} submitHandler={submit}>
        入力された内容で{乗務員給与ID ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default ZyomuinKyuyoMasterV2Register
